module.exports = __webpack_public_path__ + "img/look7.a30276a8.png";